import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, Component, Fragment } from 'react';
import { DatePicker, TimePicker } from '@progress/kendo-react-dateinputs';
import { NumericTextBox } from '@progress/kendo-react-inputs';
import moment from 'moment';
import { renderCustomColumnMenuFilter } from '../column-menu-filters';
const NoSSR = ({ children }) => {
    const [isMounted, setIsMounted] = useState(false);
    useEffect(() => {
        setIsMounted(true);
    }, []);
    return isMounted ? children : null;
};
class RangeFilterCellBase extends Component {
    constructor(props, controlClass, controlProps = {}) {
        super(props);
        Object.defineProperty(this, "controlClass", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: controlClass
        });
        Object.defineProperty(this, "controlProps", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: controlProps
        });
        Object.defineProperty(this, "minValueBox", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "maxValueBox", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "onChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (ev) => {
                if (!this.minValueBox || !this.maxValueBox) {
                    return;
                }
                this.props.onChange({
                    value: { min: this.minValueBox.value, max: this.maxValueBox.value },
                    operator: this.inRange,
                    syntheticEvent: ev.syntheticEvent,
                });
            }
        });
        Object.defineProperty(this, "setMinValueRef", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (el) => {
                this.minValueBox = el;
            }
        });
        Object.defineProperty(this, "setMaxValueRef", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (el) => {
                this.maxValueBox = el;
            }
        });
    }
    /** override this if additional type support needed */
    inRange(current, values) {
        return ((values.min === null || values.min === undefined || current >= values.min) &&
            (values.max === null || values.max === undefined || current <= values.max));
    }
    render() {
        const filterValue = this.props.value;
        const Control = this.controlClass;
        return (_jsxs(Fragment, { children: [_jsx("span", { className: "k-widget m-b-1 d-b", children: "From:" }), _jsx("span", { children: _jsx(NoSSR, { children: _jsx(Control, { ...this.controlProps, value: filterValue === null || filterValue === void 0 ? void 0 : filterValue.min, ref: this.setMinValueRef, onChange: this.onChange }) }) }), _jsx("span", { className: "k-widget m-t-1 m-b-1 d-b", children: "To:" }), _jsx("span", { children: _jsx(NoSSR, { children: _jsx(Control, { ...this.controlProps, value: filterValue === null || filterValue === void 0 ? void 0 : filterValue.max, ref: this.setMaxValueRef, onChange: this.onChange }) }) })] }));
    }
}
class NumericRangeFilterCell extends RangeFilterCellBase {
    constructor(props) {
        super(props, NumericTextBox);
    }
}
class CurrencyRangeFilterCell extends RangeFilterCellBase {
    constructor(props) {
        super(props, NumericTextBox, {
            format: 'c',
        });
    }
}
class DateRangeFilterCell extends RangeFilterCellBase {
    constructor(props) {
        super(props, DatePicker);
    }
}
function getTimeString(date) {
    return `${date.getHours()}:${date.getMinutes()}`;
}
class TimeRangeFilterCell extends RangeFilterCellBase {
    constructor(props) {
        super(props, TimePicker);
    }
    inRange(current, values) {
        return moment(getTimeString(current), 'h:mma').isBetween(moment(getTimeString(values.min || current), 'h:mma'), moment(getTimeString(values.max || current), 'h:mma'), 'minutes', '[]');
    }
}
export const NumericRangeColumnMenuFilter = renderCustomColumnMenuFilter(NumericRangeFilterCell);
export const CurrencyRangeColumnMenuFilter = renderCustomColumnMenuFilter(CurrencyRangeFilterCell);
export const DateRangeColumnMenuFilter = renderCustomColumnMenuFilter(DateRangeFilterCell);
export const TimeRangeColumnMenuFilter = renderCustomColumnMenuFilter(TimeRangeFilterCell);
//# sourceMappingURL=range-filter.js.map